
const ERROR_CODES = {
  // ServiceCallResponse
  SUCCESS: 0,
  INTERNAL_FAILURE: 1,
  INTERNAL_DATABASE_FAILURE: 2,
  INVALID_CREDENTIAL: 3,
  INVALID_USER_ID: 4,
  INVALID_USER_NAME: 5,
  INVALID_TOKEN: 6,
  UNAUTHORIZED: 7,
  ILLEGAL_ARGUMENT: 8,
  ID_NOT_EXIST: 9,
  USER_NAME_TAKEN: 10,
  USER_NAME_NOT_EXIST: 11,

  // ExtendedServiceCallResponse
  CHECK_ALREADY_APPLIED: 100011,
};

export default {
  ERROR_CODES,

  translateErrorCode(responseBody) {
    // If the server side has given us an error message, use it directly.
    if (responseBody.getErrorMsg()) {
      return responseBody.getErrorMsg();
    }

    // Return a predefined error message.
    switch (responseBody.getErrorCode()) {
      case ERROR_CODES.INTERNAL_FAILURE:
        return 'The server is busy, please try again later.';
      case ERROR_CODES.INVALID_CREDENTIAL:
        return 'The user name or password is invalid.';
      case ERROR_CODES.INVALID_USER_ID:
        return 'Invalid user id.';
      case ERROR_CODES.INVALID_USER_NAME:
        return 'User name contains invalid characters or has exceeded word limit.';
      case ERROR_CODES.INVALID_TOKEN:
        return 'Your current login token has expired.';
      case ERROR_CODES.UNAUTHORIZED:
        return 'You are not authorized to perform this action.';
      case ERROR_CODES.ID_NOT_EXIST:
        return 'Id does not exist.';
      case ERROR_CODES.USER_NAME_TAKEN:
        return 'This user name has been taken, please try another one.';
      case ERROR_CODES.USER_NAME_NOT_EXIST:
        return 'User name does not exist.';
      // ExtendedServiceCallResponse
      case ERROR_CODES.CHECK_ALREADY_APPLIED:
        return 'This check has already been applied before.';
      default:
        return `Invalid client request, error code: ${responseBody.getErrorCode()}`;
    }
  },
};
